<template>

  <div class="col  mt-4">
    <router-view></router-view>
  </div>

</template>

<script>
  export default {
    data() {
      return {

      }
    },
    methods: {

    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/kategori/_route.vue